import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trimValue } from '../../utils/utils';

@Component({
  selector: 'app-ticket-details',
  templateUrl: './ticket-details.component.html',
  styleUrls: ['./ticket-details.component.scss']
})
export class TicketDetailsPopupComponent {
  @Input() notification: any;
  @Output() viewConversation = new EventEmitter<any>();
  @Output() closePopup = new EventEmitter<void>();

  get createdOnField() {
    if (this.notification?.notificationType === 'support_ticket') {
      let field = this.notification?.notificationInstance?.Fields?.find(f => f.Code === 'created_on');
      field.Value = this.formatShortDateUS(field.Value);
      return field;
    }
    return { Label: 'Date Created', Value: this.notification?.formattedDate };
  }

   get createdByFullname() {
    if (this.notification?.notificationType === 'company_group_service_status' ) {
      return this.notification.createdByFullName;
    }
    return null;
  }

  get createdByField() {
    if (this.notification?.notificationType === 'support_ticket') {
      const createdBy = this.notification?.notificationInstance?.Fields?.find(f => f.Code === 'created_by');
      return createdBy;
    }
    if (this.notification?.notificationType === 'announcement') {
      return {};
    }
    return { Label: 'Created By', Value: this.notification?.CreatedByFullName };
  }

  get expiresOnField(){
      return { Label: 'Expires on', Value: this.notification?.formattedExpirationDate };
  }

  get locationField() {
    return this.notification?.notificationInstance?.Fields.find(f => f.Code === 'location');
  }

  get detailsField() {
      return this.notification?.notificationInstance?.Fields.find(f => f.Code === 'link');
  }

  get statusField(): any {

    if (this.notification?.notificationType === 'company_group_service_status') {
      return {};
    }

    return this.notification?.notificationInstance?.Fields?.find(f => f.Code === 'status') || {};
  }

  onViewConversationClick(): void {
    this.viewConversation.emit(this.notification.notificationInstance.PK_ID);
  }

  onClose(): void {
    this.closePopup.emit();
  }

  onOpenLink(url: any) {
  if (url) {
        window.open(addHttp(url), '_blank');
      }
  }

  trimValue(value: string){
      return trimValue(value);
  }

   private formatShortDateUS(date: Date): string {
    if (!date) return '';
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    return new Date(date).toLocaleString('en-US', options);
  }
}

function addHttp(url) {
  if (!/^(f|ht)tps?:\/\//i.test(url)) {
    url = "http://" + url;
  }
  return url;
}
